module.exports = __webpack_public_path__ + "img/fish-2.feb7544f.png";